/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Services */

/**
 * Renders the Trending component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Trending component
 */

const Trending = ({ sectionContent, trendingImages, region, lang }) => {
  const trendingData = sectionContent.body.find(
    el => el.sectionId == 'trending-this-week'
  );
  return (
    <Box
      pos="relative"
      background={`url(${trendingData.styleConfig.bgImage.url}) no-repeat center 0`}
      minHeight={{ base: '400px', lg: '600px' }}
      textAlign="center"
      color="#ffffff"
      backgroundSize={{ base: '215%', md: 'unset' }}
    >
      <Box pt={{ base: '60px', lg: '155px' }}>
        <Text
          fontSize={{ base: '12px', md: '16px' }}
          color="#ffbd31"
          margin="0 0 0 0"
          letterSpacing="2px"
          fontFamily="FedraSansStd-book"
          textTransform="uppercase"
        >
          {trendingData.sectionContent[0]?.title[0].titleSubtext}
        </Text>
        <Text
          as="h2"
          fontSize={{ lg: '50px', base: '28px' }}
          fontFamily="FedraSansStd-A-medium"
          lineHeight={{ base: '30px', md: '60px' }}
        >
          {trendingData.sectionContent[0]?.title[0].titleText}
        </Text>
      </Box>
      <Box
        display={'flex'}
        justifyContent={{ base: 'unset', md: 'center' }}
        overflowX={{ base: 'auto', md: 'unset' }}
        overflowY={{ base: 'clip', md: 'unset' }}
      >
        {trendingData.sectionContent[0]?.simpleCards.map((item, index) => (
          <Box
            key={index}
            marginRight={{ base: 'unset', md: '32px' }}
            marginLeft={{ base: '18px', md: 'unset' }}
            mt={{ base: '35px', md: '60px' }}
            _last={{ mr: '0' }}
            pos="relative"
          >
            <Box
              maxW={{ base: '142px', md: '200px', lg: '220px', '2xl': '254px' }}
              minW={{ base: '142px', md: '200px', lg: '220px', '2xl': '254px' }}
            >
              <Image
                src={trendingImages[index]?.series_thumbnails.SeriesPortrait}
                alt={item.rectangularImage.alt}
                title={item.rectangularImage.title}
                w="100%"
                borderRadius="10.7px"
              />
            </Box>
            <Box
              pos="absolute"
              bottom={{ base: '-1px', md: '-11px' }}
              right="-15px"
              zIndex="1"
              w={{ base: '25px', md: '46px' }}
            >
              <Image
                src={
                  trendingData.sectionContent[2].simpleCards[index]
                    .rectangularImage.url
                }
                alt={trendingData.sectionContent[1].image.alt}
                title={trendingData.sectionContent[1].image.title}
              />
            </Box>
            <Box pos="absolute" bottom="0">
              <Image
                src={trendingData.sectionContent[1].image.url}
                alt={trendingData.sectionContent[1].image.alt}
                title={trendingData.sectionContent[1].image.title}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Trending;
